export default function ListingPage({
  children,
  header,
  title,
  fullWidthHeader = false,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
  title: string;
  fullWidthHeader?: boolean;
}) {
  const headerWrapperClassName = fullWidthHeader ? "grow" : "ml-auto";

  return (
    <div className="flex flex-col gap-6 p-4">
      <header className="flex items-center gap-3">
        <h2 className="text-2xl font-bold text-nowrap">{title}</h2>
        <div className={headerWrapperClassName}>{header}</div>
      </header>
      {children}
    </div>
  );
}
